import React from 'react';

const PRESETS = [
	{ id: 'all', label: 'All year', months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
	{ id: 'spring', label: 'Spring (Mar–May)', months: [3, 4, 5] },
	{ id: 'autumn', label: 'Autumn (Oct–Nov)', months: [10, 11] },
];

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const ALL_MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function monthsEqual(a, b) {
	if (!a?.length || !b?.length) return false;
	if (a.length !== b.length) return false;
	return a.every((m, i) => m === b[i]);
}

function detectPreset(months) {
	if (!months?.length) return 'none';
	if (months.length === 12) return 'all';
	const match = PRESETS.find((p) => p.id !== 'all' && monthsEqual(months, p.months));
	return match ? match.id : 'custom';
}

export default function AvailableMonthsPicker({ value = [], onChange }) {
	const selected = Array.isArray(value) ? [...value].sort((a, b) => a - b) : [];
	const activePreset = detectPreset(selected);

	const applyPreset = (presetId) => {
		const preset = PRESETS.find((p) => p.id === presetId);
		if (!preset) return;
		if (preset.id === 'all') {
			onChange([...ALL_MONTHS]);
			return;
		}
		onChange([...preset.months]);
	};

	const toggleMonth = (month) => {
		const next = selected.includes(month)
			? selected.filter((m) => m !== month)
			: [...selected, month].sort((a, b) => a - b);
		onChange(next);
	};

	return (
		<div className="admin-cms-form__months">
			<p className="admin-cms-form__hint">
				Check the months when customers can book. Uncheck all to close this channel for the journey.
				All 12 months = all year.
			</p>
			<div className="admin-cms-form__month-presets">
				{PRESETS.map((p) => (
					<button
						key={p.id}
						type="button"
						className={`btn btn-sm ${activePreset === p.id ? 'btn-primary' : 'btn-outline-secondary'}`}
						onClick={() => applyPreset(p.id)}
					>
						{p.label}
					</button>
				))}
				{selected.length === 0 && (
					<span className="badge badge-secondary align-self-center">Closed — no months selected</span>
				)}
			</div>
			<div className="admin-cms-form__month-grid">
				{MONTH_NAMES.map((name, idx) => {
					const month = idx + 1;
					const isOn = selected.includes(month);
					return (
						<button
							key={month}
							type="button"
							className={`admin-cms-form__month-cell${isOn ? ' admin-cms-form__month-cell--on' : ''}`}
							onClick={() => toggleMonth(month)}
							aria-pressed={isOn}
						>
							<span className="admin-cms-form__month-check" aria-hidden="true">{isOn ? '✓' : ''}</span>
							{name}
						</button>
					);
				})}
			</div>
		</div>
	);
}

export { ALL_MONTHS };
